export const authorisedContact = {
  phone: "+91 94339 30490",
  telephone: "tel:+919433930490",
  whatsapp: "https://wa.me/919433930490",
};
